import { HiverAxios, CHANGE_STEP } from 'h-signup'
import {
    UG_CREATE_SUCCESS,
    UG_CREATE_FAILURE,
}
from './types';

const URL = '/api/signup/create-ug';

function createUGAndNavigate(params, changeToRoute) {
    return (dispatch) => {
        HiverAxios({
            url: URL,
            type: 'POST',
            params,
            callback: (response) => {
                dispatch({
                    type: UG_CREATE_SUCCESS,
                    payload: { ...params, submitInProgress: false, success: true }
                });
				dispatch({
                    type: CHANGE_STEP,
                    payload: changeToRoute
                });
            },
            onfail: (e) => {
                console.error(e);
				dispatch({
                    type: UG_CREATE_FAILURE,
                    payload: { 
                        submitError: { 
                            error: e, 
                            message: `An account name called ${params.accName} already exists. Try some other account name.`
                        }, 
                        submitInProgress: false 
                    }
                });
            }
        })
    }
}
export default createUGAndNavigate;
